import AvoidPreferencesView from "./AvoidPreferencesView"
export default AvoidPreferencesView
